<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data request RRD."
            @click="save()"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustName" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Effective Rate (%)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.bunga_tarifthn" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">%</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.purpose_of_fin_name" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Cessie Group</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pjxname" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.branch" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.LDSK" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>RRD Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.rrd_dt_frmt" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Expired Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.expired_date_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
      <hr />
      
      <b-row>
        <b-col lg="12">
          <b-row>
              <b-col md="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Request No.</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.requestno" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Request Date</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="model.requestdate" :state="!$v.model.requestdate.$error" />
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Request By</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.requestby" disabled></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Release to</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.releaseto" :state="!$v.model.releaseto.$error"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row > 
          <b-input-group>
            <b-input-group-prepend>
              <label>Keterangan</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="model.uraian"
              placeholder=""
              rows="5"
              max-rows="10"
            ></b-form-textarea>
          </b-input-group>
        </b-col>
      </b-row>
      <hr />
      <b-table
        sticky-header 
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;max-height:500px !important;"
        :items="tblDataAsset.items"
        :fields="tblFieldsAsset"
        :current-page="tblDataAsset.page"
        :per-page="tblDataAsset.limit"
        :sort-by.sync="tblDataAsset.sortBy"
        :sort-desc.sync="tblDataAsset.sortDesc"
        :key="tblDataAsset.limit"
        :busy="isBusyTblAngsuran"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
        caption-top
      >
      <template #table-caption><h5>Daftar Jaminan</h5></template>  
      <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(nilaijaminan)="data">
          {{data.item.nilaijaminan | numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(nilaimargin)="data">
          {{data.item.nilaimargin | numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(nilailikuidasi)="data">
            {{data.item.nilailikuidasi | numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(alamat)="data">
          {{ data.item.alamat || "-" }}
          
          <span v-if="(data.item.kelurahan ||'')!=''">
            <br />
              Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
            data.item.kecamatan
          }}</span>
          <span v-if="(data.item.kota||'')!=''">
            <br />
            Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
          </span>
          <span v-if="(data.item.kodepos||'')!=''">
            <br />
            Kode Pos : {{ data.item.kodepos }}
          </span>
          
        </template>
        <template v-slot:cell(detail)="data">
          <span v-if="data.item.tipejaminan == 'Kendaraan'">
            <b-row>
              <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
              <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
              <b-col md="6"
                >- Tanggal STNK :
                {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col
              >
            </b-row>
          </span>
          <span v-else>
            <b-row>
              <b-col md="6"
                >- No Sertifikat : {{ data.item.sertifikatno }}</b-col
              >
              <b-col md="6"
                >- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col
              >
            </b-row>
            <b-row>
              <b-col md="6">
                - Luas Tanah : {{ data.item.luastanah }} m
                <sup>2</sup>
              </b-col>
              <b-col md="6">
                - Luas Bangunan : {{ data.item.luasbangunan }} m
                <sup>2</sup>
              </b-col>
            </b-row>
            - Status Sertifikat : {{ data.item.sertifikatstatus }}
            <span v-if="data.item.sertifikatstatus === 'lainnya'"
              >- {{ data.item.otherstatussertifikat }}</span
            >
            <b-row>
              <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
              <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6"
                >- Status Asuransi : {{ data.item.statusasuransi }}</b-col
              >
              <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
            </b-row>
          </span>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div align="left">
            Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
            to
            <span
              v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)"
            >{{tblDataAsset.total}}</span>
            <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
            of {{tblDataAsset.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25,50,75,100]"
                  :plain="true"
                  v-model="tblDataAsset.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblDataAsset.total"
            :per-page="tblDataAsset.limit"
            v-model="tblDataAsset.page"
            @click="getAssetData()"
          ></b-pagination>
        </b-col>
      </b-row>

      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data request RRD."
            @click="save()"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>   
  </div>
</template>

<style lang="scss" scoped>
  .table-red-text{
    color:red;
  }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';

import pinjaman from "../../apis/pinjamankredit";
import releasedoc from "../../apis/releasedoc";
import asset from "../../apis/agunankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading},
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
      requestdate: { required },
      releaseto: { required },
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      tabIndex:0,
      model: { requestkey:"",pinjamankey: "",requestdate:"",
      releaseto: "",paketpengirim:"",noresi:"",releaseAssets:[]
      },
      lkuPinjamanShow: false,
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "",
      filterOn: ["statuspay"],

      optReleaseTo: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "self", text: "Diambil Sendiri oleh Debitur" },
        { value: "package", text: "Kirim via Paket" },
      ],

    };
  },
  props: ["modelpinjaman"],
  computed: {
    tblFieldsAsset() {
      const fields = [
        { key: "index", label: "#" },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:1500px",
          sortable: true,
        },
        
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilaimargin",
          label: "Nilai Margin",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilailikuidasi",
          label: "Nilai Likuidasi",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        }
      ];
      return fields;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },

  beforeUpdate: function () {},
  created: async function () {

    if (this.$route.params.releaseKey) {
      this.isdetail = true;
      try {
        this.isLoading = true;
        const res = await releasedoc.detail(this.$route.params.releaseKey);
        const dtheader = res[0][0];
        for (const key in dtheader) {
          if (dtheader.hasOwnProperty(key)) {
            this.model[key] = dtheader[key];
          }
        }
        this.model.uraian = `Pelepasan Jaminan Sebagian Memo No. : ${this.model.releaseno}`
        const dtasset = res[1];
        this.tblDataAsset.items=dtasset;
        this.tblDataAsset.total = dtasset.length;
      
        const dtRequestCurr = await pinjaman.requestCurr();
        this.model.requestno = dtRequestCurr ? dtRequestCurr : "";
        this.model.requestby = `${this.$store.state.user.full_name ? this.$store.state.user.full_name : ""} ${this.$store.state.user.jabatan ? `| ${this.$store.state.user.jabatan}` : ""}`;    

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }

    } else {
     
    }
    this.model.releaseto = this.model.releaseto ? this.model.releaseto : this.model.CustName;
  },
  watch:{},
  methods: {
    rowClass(item, type) {
      const today = moment().format('YYYY-MM-DD');
        if ((item && item.outstand_bunga ||0)>0.009 || (item && item.outstand_pokok||0) > 0.009) {
          if(moment(today).diff(moment(item.tgl_jttempo),'days')>-1){
            return 'text-danger';
          }else{
            return '';
          }
            
        }else{
          return '';
        }
        
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },

    async save() {
      if(this.invalidModel){
        if (this.$v.model.$model.requestdate && this.$v.model.$model.releaseto && this.$v.model.$model.selected && this.$v.model.$model.selected.length === 0) {
          toastr.error("Please checked jaminan first!", "ERROR MESSAGE");
        }else{
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        }
      }else {
        
          this.model.releaseAssets = this.tblDataAsset.items||[];
          await releasedoc.saveRequestRRD(this.model);
          toastr.success("Request RRD berhasil disimpan");
          router.push({ name: "loan.pelepasandokumensebagian" });
      }
    },
    close() {
      router.push({ name: "loan.pelepasandokumensebagian" });
    },
  },
};
</script>